import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { AfterViewInit, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';
import * as CookieConsent from 'vanilla-cookieconsent';

import { CCConfig } from './util/cookie-consent-config';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, ToastModule, ButtonModule, DividerModule, PasswordModule, FormsModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: []
})
export class AppComponent implements AfterViewInit {
  constructor() {
    registerLocaleData(localeDe, 'de-DE', localeDeExtra);
  }

  ngAfterViewInit() {
    void CookieConsent.run(CCConfig);
  }
}
